import { Calculator } from 'lucide-react';
import { formatMinor, TaxLineRow, TaxReportCard, TaxStatCell, TaxStatStrip } from './taxReportShared';

interface BreakdownLine {
  label: string;
  amountMinor: number;
}

interface Data {
  type: string;
  periodEnd: string;
  netProfitMinor: number;
  federalEstimate: { estimatedTaxMinor: number; breakdown: BreakdownLine[] };
  stateEstimate: { state: string; estimatedTaxMinor: number; label: string } | null;
  totalEstimatedTaxMinor: number;
}

export function TaxEstimateReport({ data }: { data: Record<string, unknown> }) {
  const d = data as unknown as Data;
  const federal = d.federalEstimate?.breakdown ?? [];

  return (
    <TaxReportCard icon={Calculator} title="Tax Estimate (US)" badge={`As of ${d.periodEnd}`}>
      <TaxStatStrip>
        <TaxStatCell label="Net profit YTD" value={formatMinor(d.netProfitMinor)} />
        <TaxStatCell label="Estimated tax" value={formatMinor(d.totalEstimatedTaxMinor)} emphasis />
      </TaxStatStrip>

      <table className="w-full text-sm">
        <thead>
          <tr className="bg-surface-50/60 text-[11px] uppercase tracking-[0.06em] text-surface-500">
            <th className="px-4.5 py-2 text-left font-medium">Federal</th>
            <th className="px-4.5 py-2 text-right font-medium">Amount</th>
          </tr>
        </thead>
        <tbody>
          {federal.map((line) => (
            <TaxLineRow key={line.label} label={line.label} value={formatMinor(line.amountMinor)} />
          ))}
          <TaxLineRow
            label="Federal subtotal"
            value={formatMinor(d.federalEstimate?.estimatedTaxMinor)}
            strong
          />
          {d.stateEstimate ? (
            <TaxLineRow
              label={d.stateEstimate.label}
              value={formatMinor(d.stateEstimate.estimatedTaxMinor)}
              strong
            />
          ) : null}
          <TaxLineRow
            label="Total estimated tax"
            value={formatMinor(d.totalEstimatedTaxMinor)}
            strong
          />
        </tbody>
      </table>
    </TaxReportCard>
  );
}
